import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { Link } from "react-router-dom";
import UseTitle from "../../Hooks/UseTitle";
import relaxCover from "../../../Assets/Hompage/Relaxation/relaxation-cover.jpeg";
import relaxCoverMobile from "../../../Assets/Relaxationmobile.jpg";
import swimming from "../../../Assets/Hompage/Swimming/Swimming1 (2).jpeg";
import swimming1 from "../../../Assets/Hompage/Swimming/Swimming1 (1).jpeg";
import swimming2 from "../../../Assets/Hompage/Swimming/Swimming1 (3).jpeg";
import swimming3 from "../../../Assets/Hompage/Swimming/Swimming1 (4).jpeg";
import recreation from "../../../Assets/Hompage/Recreation/recreation (3).jpeg";
import recreation1 from "../../../Assets/Hompage/Recreation/recreation (1).jpeg";
import recreation2 from "../../../Assets/Hompage/Recreation/recreation (2).jpeg";
import restaurant1 from "../../../Assets/Hompage/Restaurant/Restaurant (4).jpeg";
import restaurant2 from "../../../Assets/Hompage/Restaurant/Restaurant (5).jpeg";
import restaurant3 from "../../../Assets/Hompage/Restaurant/Restaurant (3).jpeg";
import restaurant4 from "../../../Assets/Hompage/Restaurant/Restaurant (1).jpeg";
import restaurant5 from "../../../Assets/Hompage/Restaurant/Restaurant (2).jpeg";
import playGround from "../../../Assets/Hompage/playGround/playGround (1).jpg";
import playGround1 from "../../../Assets/Hompage/playGround/playGround (2).jpg";
import playGround2 from "../../../Assets/Hompage/playGround/playGround (3).jpg";
import playGround3 from "../../../Assets/Hompage/playGround/playGround (4).jpg";
import playGround4 from "../../../Assets/Hompage/playGround/playGround (5).jpg";
const Relaxation = () => {
  UseTitle("Relaxation");
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 1,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };
  return (
    <div className="bg-gray-100">
      <div className="pt-16 md:pt-10 hidden md:block">
        <img className="w-full" src={relaxCover} alt="Relaxation" />
      </div>
      <div className="pt-16 md:pt-10 md:hidden block">
        <img className="w-full" src={relaxCoverMobile} alt="Relaxation" />
      </div>
      <div className="max-w-screen-xl mx-auto pb-10 md:px-0 px-8">
        <div className="mt-20">
          {/* max-w-7xl mx-auto */}
          <div className="flex justify-start ">
            <div className="">
              <div className="nahid-title-designer ">
                <h1
                  data-aos="zoom-in"
                  className="text-[30px] md:text-[40px] font-bold tracking-wide "
                >
                  Relaxation
                </h1>
                <p className="text-[18px] mt-10 text-justify">
                  Escape to Paradise: Experience Luxury and Serenity at Our
                  Premier Resort.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="grid md:grid-cols-2 grid-cols-1 gap-10 my-20">
          {/* swimming */}

          <div className="bg-white">
            <Link to="/Swimming_Pool">
              <div className=" ">
                <Carousel
                  autoPlaySpeed={3000}
                  autoPlay={true}
                  arrows={false}
                  infinite={true}
                  responsive={responsive}
                  className=""
                >
                  <div className="relative md:m-5 room-hover">
                    <Link to="/Swimming_Pool">
                      <img
                        src={swimming}
                        alt="swimming"
                        className="relative z-1"
                      />
                    </Link>
                  </div>
                  <div className="md:m-5">
                    <img src={swimming1} alt="" className="relative z-1" />
                  </div>
                  <div className="md:m-5">
                    <img src={swimming2} alt="" className="relative z-1" />
                  </div>
                  <div className="md:m-5">
                    <img src={swimming3} alt="" className="relative z-1" />
                  </div>
                </Carousel>
              </div>

              <h1 className="text-center my-10 text-[25px]">
                The Swimming Pool
              </h1>
              <p className="mb-10 md:px-10 px-5 text-justify md:text-start">
                Our resort is designed to provide a luxurious and relaxing
                experience for all our guests. Here, you can enjoy not one, but
                two stunning swimming pools! For the adults, we have a spacious
                crystal clear swimming pool that is perfect for taking a
                refreshing dip on a hot day. You can take a swim anytime here
                that provides the perfect atmosphere for relaxation. For our
                younger guests, we have a separate swimming pool just for kids.
                The pool is designed with their safety in mind, and the water is
                shallow enough for children to play in with ease. The pool is
                also well-maintained and cleaned regularly to ensure a hygienic
                environment for your little ones.
              </p>
            </Link>
          </div>

          {/* playZone1 */}

          <div className="bg-white">
            <Link to="/play-Ground">
              <Link to="/play-Ground">
                <div className=" ">
                  <Carousel
                    autoPlaySpeed={3000}
                    autoPlay={true}
                    arrows={false}
                    infinite={true}
                    responsive={responsive}
                    className=""
                  >
                    <div className="relative md:m-5 room-hover">
                      <img
                        src={playGround}
                        alt="Playground"
                        className="relative z-1"
                      />
                    </div>
                    <div className="md:m-5">
                      <img
                        src={playGround1}
                        alt="Playground"
                        className="relative z-1"
                      />
                    </div>
                    <div className="md:m-5">
                      <img
                        src={playGround2}
                        alt="Playground"
                        className="relative z-1"
                      />
                    </div>
                    <div className="md:m-5">
                      <img
                        src={playGround3}
                        alt="Playground"
                        className="relative z-1"
                      />
                    </div>
                    <div className="md:m-5">
                      <img
                        src={playGround4}
                        alt="Playground"
                        className="relative z-1"
                      />
                    </div>
                  </Carousel>
                </div>
              </Link>
              <h1 className="text-center my-10 text-[25px]">
                Play Ground for different games
              </h1>
              <p className="mb-10 md:px-10 px-5 text-justify md:text-start">
                In our exciting play zone, where kids can let loose, play, and
                have fun! Our play zone features a variety of different play
                equipment like a spacious and well-maintained ground that
                provides the perfect space for kids to run around and play. This
                open space is the ideal spot for kids to burn off some energy
                and get moving. Next, we have a classic swing that is sure to
                bring a smile to any child's face, and is secured firmly in the
                ground to provide a stable and secure play experience. We also
                have an exciting slider that will give your child an adrenaline
                rush as they speed down it. And last but not least, we have a
                challenging and exciting monkey bar that will put your child's
                strength and agility to the test. With our range of play
                equipment and safe, well-maintained environment, you can be sure
                that your kids will have a blast while staying safe and secure.
              </p>
            </Link>
          </div>

          {/* recreation */}
          <div className="bg-white">
            <Link to="/Recreation">
              <Link to="/Recreation">
                <div className=" ">
                  <Carousel
                    autoPlaySpeed={3000}
                    autoPlay={true}
                    infinite={true}
                    arrows={false}
                    responsive={responsive}
                    className=""
                  >
                    <div className="md:m-5">
                      <img
                        src={recreation}
                        alt="recreation"
                        className="relative z-1"
                      />
                    </div>
                    <div className="relative md:m-5 room-hover">
                      <img
                        src={recreation1}
                        alt="recreation"
                        className="relative z-1"
                      />
                    </div>

                    <div className="md:m-5">
                      <img
                        src={recreation2}
                        alt="recreation"
                        className="relative z-1"
                      />
                    </div>
                  </Carousel>
                </div>
              </Link>
              <h1 className="text-center my-10 text-[25px]">Recreation</h1>
              <p className="mb-10 md:px-10 px-5 text-justify md:text-start">
                You’ll find our beautiful recreational area, where you can take
                a break from the hustle and bustle of everyday life and enjoy
                some time surrounded by nature. We have a range of seating
                options available for you to relax and take in the stunning
                scenery. Also, you can sit on one of our benches located right
                beside the water and enjoy the sound of the gently lapping waves
                or the singing of the birds in the trees. We have a swing
                located right beside the lake that offers a thrilling and
                enjoyable ride while taking in the serene beauty of the
                surrounding nature.
              </p>
            </Link>
          </div>
          {/* restaurant */}
          <div className="bg-white">
            <Link to="/Restaurant">
              <Link to="/Restaurant">
                <div className=" ">
                  <Carousel
                    autoPlaySpeed={3000}
                    autoPlay={true}
                    infinite={true}
                    arrows={false}
                    responsive={responsive}
                    className=""
                  >
                    <div className="md:m-5">
                      <img
                        src={restaurant1}
                        alt="Restaurant"
                        className="relative z-1"
                      />
                    </div>
                    <div className="md:m-5">
                      <img
                        src={restaurant2}
                        alt="Restaurant"
                        className="relative z-1"
                      />
                    </div>

                    <div className="md:m-5">
                      <img
                        src={restaurant3}
                        alt="Restaurant"
                        className="relative z-1"
                      />
                    </div>
                    <div className="md:m-5">
                      <img
                        src={restaurant4}
                        alt="Restaurant"
                        className="relative z-1"
                      />
                    </div>
                    <div className="md:m-5">
                      <img
                        src={restaurant5}
                        alt="Restaurant"
                        className="relative z-1"
                      />
                    </div>
                  </Carousel>
                </div>
              </Link>
              <h1 className="text-center my-10 text-[25px]">Restaurant</h1>
              <p className="mb-10 md:px-10 px-5 text-justify md:text-start">
                With a capacity of nearly 100 people, we have an iconic grand
                restaurant, where you can enjoy a delicious meal while taking in
                the breathtaking natural scenery. Our restaurant has been
                meticulously designed to offer the perfect blend of comfort,
                elegance, and natural beauty, and we are proud to offer a unique
                dining experience that you won't find anywhere else. We offer a
                range of dining options to suit every taste and preference. Our
                buffet is particularly popular, offering a wide range of
                delicious dishes that are sure to satisfy even the most
                discerning palate. From savory entrees to delectable desserts,
                our buffet is a feast for the senses that is not to be missed.
              </p>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Relaxation;
